// The task path choice's controls (2026-10-29, extracted from
// SuggestionPanel.jsx so the main panel and the admin agent draft column
// show the same step and can't drift; docs/contact-view.md "Return Status").
// The radios, the preselection and why under it, the date field the chosen
// option needs (the browser's date input: MM/DD/YYYY in US English), "Choose
// one to see the next steps." until a choice, who chose, the date warning,
// the step's own error line, and the agent's sentences that led to it
// (sources, "Agent: ...", when the step was merged from several).
//
// Presentational: the caller owns the choice, the date and what saving them
// does. testIdPrefix keeps the two panels' test ids apart ('task-path' on the
// main panel, as before).
import { Box, FormControlLabel, Radio, RadioGroup, TextField, Typography } from '@mui/material'
import { isIsoDate } from '@cxhub/shared'

export default function TaskPathChoiceControls({
  options = [], value = null, onChange, preselected = null, showPreselected = true,
  date = '', onDateChange, disabled = false, dateDisabled = false, showDate = true,
  chosenBy = null, error = null, sources = [], boxRef = null, highlighted = false, outlined = highlighted,
  testIdPrefix = 'task-path', testId = 'task-path-choice', sx = {},
}) {
  const chosenOption = (options ?? []).find((o) => o.value === value)
  const agentLines = (sources ?? []).filter((t) => String(t ?? '').trim())
  return (
    <Box ref={boxRef} data-testid={testId} data-highlighted={highlighted ? '1' : undefined}
      sx={{ flexBasis: '100%', ...(outlined ? { outline: '2px solid', outlineColor: 'error.main', outlineOffset: 2, borderRadius: 1 } : {}), ...sx }}>
      {agentLines.length > 0 && (
        <Box data-testid={`${testIdPrefix}-sources`}>
          {agentLines.map((t, i) => <Typography key={i} variant="caption" display="block" color="text.secondary">Agent: {t}</Typography>)}
        </Box>
      )}
      <RadioGroup value={value ?? ''} onChange={(e) => onChange?.(e.target.value)}>
        {(options ?? []).map((o) => (
          <FormControlLabel key={o.value} value={o.value} disabled={disabled}
            control={<Radio size="small" inputProps={{ 'data-testid': `${testIdPrefix}-${o.value}` }} />}
            label={<Typography variant="body2">{o.label}</Typography>} />
        ))}
      </RadioGroup>
      {/* A preselection and why (2026-10-21); the agent can change it. */}
      {showPreselected && preselected?.value && value === preselected.value && (
        <Typography variant="caption" display="block" color="text.secondary" data-testid={`${testIdPrefix}-preselected`}>Preselected: {preselected.reason}</Typography>
      )}
      {showDate && chosenOption?.dateRequired && (
        <TextField size="small" type="date" label={chosenOption.dateLabel ?? 'Date'} value={date ?? ''}
          onChange={(e) => onDateChange?.(e.target.value)} disabled={dateDisabled}
          InputLabelProps={{ shrink: true }} inputProps={{ 'data-testid': `${testIdPrefix}-date` }} sx={{ mt: 0.75, width: 220 }} />
      )}
      {value
        ? (chosenBy && <Typography variant="caption" display="block" color="text.secondary" data-testid={`${testIdPrefix}-chosen-by`}>Chosen by {chosenBy}</Typography>)
        : <Typography variant="caption" color="warning.dark">Choose one to see the next steps.</Typography>}
      {chosenOption?.dateRequired && !isIsoDate(date) && (
        <Typography variant="caption" display="block" color="warning.dark">Enter the {String(chosenOption.dateLabel ?? 'date').toLowerCase()} before sending.</Typography>
      )}
      {/* The step's own error line (2026-10-28): a choice or date not
          saved, or Send refused for the choice. */}
      {error && (
        <Typography variant="caption" display="block" color="error.dark" role="alert" data-testid={`${testIdPrefix}-error`} sx={{ fontWeight: 600 }}>
          {error}
        </Typography>
      )}
    </Box>
  )
}
